import React from 'react';
import { Contact } from 'flow/types/Contact';
import { TypedMap } from 'flow/types/TypedMap';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { useAppSelector } from 'flow/hooks/useRedux';
import { selectContact } from 'flow/selectors/ExtensionSelectors';
import ContactModalShell from './ContactModalShell';

interface Props {
    contact?: TypedMap<Contact>;
    extensionKey?: ExtensionKey;
}

const ContactModal = ({ contact, extensionKey }: Props) => {
    const extensionContact = useAppSelector((state) =>
        extensionKey ? selectContact(state, extensionKey) : null,
    );

    return <ContactModalShell contact={contact || extensionContact} />;
};

export default ContactModal;
